export const getFirstParam = (params) => {
  if (Array.isArray(params)) {
    return params.find(() => true);
  }
  return params;
};
